<template>
  <rich-tooltip
    v-bind="$attrs"
    :header="$t('creator.samplesStep')"
    :title="$t('creator.samplesTipTitle')"
    :text="$t('creator.samplesTipText')"
    icon="ImageIcon"
  />
</template>

<script>
import RichTooltip from '@/views/components/proposals/components/RichTooltip.vue';

export default {
  name: 'SamplesTip',
  components: {
    RichTooltip,
  },
}
</script>
